/** The named identity shared by brand, branch and category picker options. */
export type NamedOption = { id: string; name: string };

export const nameOfOption = (
    options: readonly NamedOption[],
    id: string | null,
): string | null =>
    id === null
        ? null
        : (options.find((option) => option.id === id)?.name ?? null);
